<template>
	<span
		:class="['Tag', variant]"
		:aria-label="label"
	>
		{{ label }}
		<span
			v-if="counter"
			class="Counter"
			:aria-label="`+${counter} more`"
		>
			+{{ counter }}
		</span>
	</span>
</template>
<script setup lang="ts">
const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	counter: {
		type: Number,
		required: false,
	},
	variant: {
		type: String,
		required: false,
		default: 'default',
	},
});
</script>

<style scoped lang="scss">
	.Tag {
		display: flex;
		height: 1.5rem;
		align-items: center;
		border-radius: 0.25rem;
		user-select: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		@include TextStyle(UiSmallSemibold);
		@include PaddingAreas(0, 0.25);

		&.default {
			background-color: $Grey-100;
			color: $Grey-900;
		}

		.Counter {
			color: $Grey-700;
			@include MarginAreas(0, 0, 0, 0.25);
		}
	}
</style>
